import { createAction } from "@reduxjs/toolkit";
import type { AdminStudentVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveStudent = createApiThunk<AdminStudentVM, string>(
  "students/retrieveStudent",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.getStudent(id);
  },
);

export const resetRetrieveStudent = createAction("students/resetRetrieveStudent");
